/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

import {
  PostContentSchemaGrantType,
  AuthenticationExchangeAadAccessTokenForAcrRefreshTokenOptionalParams,
  AuthenticationExchangeAadAccessTokenForAcrRefreshTokenResponse,
  TokenGrantType,
  AuthenticationExchangeAcrRefreshTokenForAcrAccessTokenOptionalParams,
  AuthenticationExchangeAcrRefreshTokenForAcrAccessTokenResponse
} from "../models/index.js";

/** Interface representing a Authentication. */
export interface Authentication {
  /**
   * Exchange AAD tokens for an ACR refresh Token
   * @param grantType Can take a value of access_token_refresh_token, or access_token, or refresh_token
   * @param service Indicates the name of your Azure container registry.
   * @param options The options parameters.
   */
  exchangeAadAccessTokenForAcrRefreshToken(
    grantType: PostContentSchemaGrantType,
    service: string,
    options?: AuthenticationExchangeAadAccessTokenForAcrRefreshTokenOptionalParams
  ): Promise<AuthenticationExchangeAadAccessTokenForAcrRefreshTokenResponse>;
  /**
   * Exchange ACR Refresh token for an ACR Access Token
   * @param service Indicates the name of your Azure container registry.
   * @param scope Which is expected to be a valid scope, and can be specified more than once for multiple
   *              scope requests. You obtained this from the Www-Authenticate response header from the challenge.
   * @param refreshToken Must be a valid ACR refresh token
   * @param grantType Grant type is expected to be refresh_token
   * @param options The options parameters.
   */
  exchangeAcrRefreshTokenForAcrAccessToken(
    service: string,
    scope: string,
    refreshToken: string,
    grantType: TokenGrantType,
    options?: AuthenticationExchangeAcrRefreshTokenForAcrAccessTokenOptionalParams
  ): Promise<AuthenticationExchangeAcrRefreshTokenForAcrAccessTokenResponse>;
}
